// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-20c783dc]{display:none}.wrapper__title[data-v-20c783dc]{margin-bottom:var(--spacer-sm)}.wrapper__list[data-v-20c783dc]{margin:0;padding:0}.wrapper__list[data-v-20c783dc] p{margin:0}.wrapper__list[data-v-20c783dc] .list-item__description{margin:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
